// app/providers.js
"use client";
import posthog from "posthog-js";
import {
  ANALYTICS_ENVIRONMENT_PROPERTY,
  resolveAnalyticsEnvironment,
} from "@/lib/analytics/environment";
import { PostHogProvider } from "posthog-js/react";
import { useEffect, useRef } from "react";

export function CSPostHogProvider({ children }: { children: React.ReactNode }) {
  const initializationRef = useRef(false);

  useEffect(() => {
    if (initializationRef.current) {
      return; // Already initialized, skip
    }
    const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

    if (posthogKey && posthogHost) {
      initializationRef.current = true;
      posthog.init(posthogKey, {
        api_host: posthogHost,
        debug: false,
        disable_session_recording: process.env.NODE_ENV === "development",
      });
      // A super property rather than a per-call one: it belongs on every event
      // including the SDK's own ($pageview, $exception), and no call site
      // should have to remember it.
      posthog.register({
        [ANALYTICS_ENVIRONMENT_PROPERTY]: resolveAnalyticsEnvironment(),
      });
      console.log("📊 [PostHog]: Initialized successfully");
    } else {
      console.log("📊 [PostHog]: Skipping initialization - missing environment variables");
    }
  }, []);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
